import { linkedPackage } from "lincd/lib/utils/Module";

export const {
    linkedComponent,
    linkedComponentClass,
    linkedShape,
    linkedUtil,
    linkedOntology,
    registerPackageModule,
    registerPackageExport,
    packageExports,
} = linkedPackage("lincd-quora-ads");
